/**
 * Dev-only logger.
 *
 * In development builds (`process.env.NODE_ENV !== 'production'`) this behaves
 * exactly like the browser `console`. In production builds the methods become
 * no-ops so we don't leak diagnostic information to end users and don't pay
 * the perf cost of formatting/serialising values that are never seen.
 *
 * Use it as a drop-in replacement for `console.*` inside app code:
 *
 *   import { logger } from "@/lib/logger";
 *   logger.error("failed to load dashboard", err);
 */
const isDev = process.env.NODE_ENV !== "production";
const noop = () => {};

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: isDev ? console.error.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
};

export default logger;
